import { useDialog } from '@/lib/hooks/use-dialog'

export const useCaseAlertItem = () => {
  const {
    isDialogOpen: isCaseAlertUpdateDialogOpen,
    openDialog: openCaseAlertUpdateDialog,
    closeDialog: closeCaseAlertUpdateDialog,
  } = useDialog()

  return {
    isCaseAlertUpdateDialogOpen,
    openCaseAlertUpdateDialog,
    closeCaseAlertUpdateDialog,
  }
}
